import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateEmployerUpdatedWebhook = (axios: IAxiosInstance) => {
  return async ({
    employerUpdatedWebhook,
    userType,
    isTestWebhookType,
    usePrimary,
  }: ISchema["#/definitions/IUpdateEmployerUpdatedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateEmployerUpdatedWebhookResponse"]
    >(
      `/api/updateEmployerUpdatedWebhook${getUsePrimaryUrlParams(usePrimary)}`,
      {
        employer_update_webhook: employerUpdatedWebhook,
        user_type: userType,
        is_test_webhook_type: isTestWebhookType,
      }
    );

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
